import React from 'react';
import CreatePacientePage from '../../features/pacientes/pages/CreatePacientePage';
import ExportDataPage from '../../features/pacientes/pages/ExportDataPage';
import PacientesHomePage from '../../features/pacientes/pages/PacientesHomePage';
import UserProfilePage from '../../features/users/pages/UserProfilePage';
import UsersManagementPage from '../../features/users/pages/UsersManagementPage';
import ImportEncoderCsvPage from '../../features/encoder/pages/ImportEncoderCsvPage';

export const adminRoutes = [
  { path: '/homeAdmin', element: <PacientesHomePage /> },
  { path: '/crear-paciente', element: <CreatePacientePage /> },
  { path: '/lista-usuarios', element: <UsersManagementPage /> },
  { path: '/ver-admin', element: <UserProfilePage /> },
  { path: '/exportar-datos', element: <ExportDataPage /> },
  { path: '/importar-encoder-csv', element: <ImportEncoderCsvPage /> },
];
